import { RootState } from '../redux/store';
import { useSelector, useDispatch } from 'react-redux';
import { PRODUCTS_SLUG } from '../shared/constants/SlugsProducts';
import { useEffect, useState } from 'react';
import { prebillingAvailable } from '../services/suscription.service';
import { ENABLE_PREBILLING_FOR_YEAR } from '../shared/constants/prices';
import { Products } from '../@types/Products.type';
import { addAcquisitions } from '../redux/slices/products.slice';
import { fetchAcquisitions } from '../services/shopping.service';

const usePurchases = () => {
	const [isLoading, setIsLoading] = useState({
		adquisitions: false,
	});
	const dispatch = useDispatch();
	const { tokenSession } = useSelector((state: RootState) => state.auth);
	const { acquisitions } = useSelector((state: RootState) => state.productList);
	const { activeSuscriptions } = useSelector(
		(state: RootState) => state.profile,
	);
	const { subscriptions } = useSelector((state: RootState) => state.profile);
	const userAnnualSubscriptions = subscriptions?.filter(
		(sub) =>
			sub?.product_version?.product?.slug === PRODUCTS_SLUG.ANNUAL_DECLARATION,
	);

	const userAnnualAcquisition = acquisitions?.some(
		(acquisition) =>
			acquisition?.product?.default_product_version_id === Products.AnnualPt &&
			acquisition?.additional_information?.year &&
			acquisition?.additional_information?.year?.toString() === '2024' &&
			!acquisition?.additional_information?.month,
	);

	const [havePrebillingAvailable, setHavePrebillingAvailable] = useState<
		boolean | null
	>(null);

	const getAcquisitions = async () => {
		try {
			setIsLoading({ ...isLoading, adquisitions: true });
			const response = await fetchAcquisitions(tokenSession);
			dispatch(addAcquisitions(response));
		} catch (error) {
		} finally {
			setIsLoading({ ...isLoading, adquisitions: false });
		}
	};

	const userHavePurchases =
		acquisitions.length > 0 || activeSuscriptions.length > 0;

	const annualSubIsRenewed = userAnnualSubscriptions?.some(
		(sub) =>
			sub.current_period_end &&
			new Date(sub.current_period_end) >= new Date('2025-06-01'),
	);

	const userHasAnnualSubscription = annualSubIsRenewed || userAnnualAcquisition;

	const prebillingAvailableCheck = async () => {
		const response = await prebillingAvailable(tokenSession);
		const subscriptionsAnnual = response.annual;
		if (subscriptionsAnnual.length > 0) {
			const [subscriptionAnnual] = subscriptionsAnnual;
			if (
				!subscriptionAnnual.years_covered.includes(
					ENABLE_PREBILLING_FOR_YEAR,
				) &&
				!userHasAnnualSubscription
			) {
				setHavePrebillingAvailable(true);
			}
		}
	};

	useEffect(() => {
		(async () => {
			await prebillingAvailableCheck();
			await getAcquisitions();
		})();
	}, []);

	return {
		userHavePurchases,
		havePrebillingAvailable,
		userHasAnnualSubscription,
	};
};
export default usePurchases;
